import * as React from 'react';
/**
 *
 * Original name: import contacts
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A537
 *
 */
export const ImportContactsSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M107 93H83.443a38.933 38.933 0 0 0 6.241-8.658l-5.364-2.687C84.274 81.743 79.745 90.432 73 93v6c6.745 2.568 11.274 11.257 11.317 11.342l5.366-2.684A38.929 38.929 0 0 0 83.443 99H107v-6Z", fill: "currentColor" }),
    React.createElement("path", { d: "M25 80a17.02 17.02 0 0 1 17-17h36a17.02 17.02 0 0 1 17 17h6a23.027 23.027 0 0 0-23-23h-4.13C77.188 53.047 79 47.265 79 40c0-14.4-7.1-23-19-23s-19 8.6-19 23c0 7.265 1.812 13.047 5.13 17H42a23.026 23.026 0 0 0-23 23v19h48v-6H25V80Zm22-40c0-7.755 2.256-17 13-17s13 9.245 13 17c0 7.755-2.256 17-13 17s-13-9.245-13-17Z", fill: "currentColor" })));
